import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({ archiveSite: 'archiveJobSite' }),
    async archiveJobSite(jobSite) {
      if (confirm('Are you sure you want to delete this job site?')) {
        await this.archiveSite({ jobSiteId: jobSite.id });
        this.$appMessage('Job site deleted');
      }
    },
  },
};
